import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  DialogComponent,
} from '@core/user-interface-legacy';

export interface ChangeLoginMethodConfirmDialog {
  email: string;
  username: string;
  memberGuid: string;
}

@Component({
  selector: 'rt-change-login-method-confirm-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @let emailValue = email();
    @let usernameValue = username();
    <rt-confirm-dialog
      [title]="'tlc.members.edit_member.change_login_method_confirm_dialog.title' | translate"
      [agreeLabel]="'tlc.common.confirm' | translate"
      [cancelLabel]="'tlc.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
    >
      <div layout-vertical>
        <div layout-vertical margin-bottom>
          <span text-bold text-color>
            {{
              'tlc.members.edit_member.change_login_method_confirm_dialog.email_verification_title'
                | translate
            }}
          </span>
          <span
            [innerHTML]="
              'tlc.members.edit_member.change_login_method_confirm_dialog.email_verification_description'
                | translate: { email: emailValue }
            "
          >
          </span>
        </div>
        <div layout-vertical margin-bottom>
          <span text-bold text-color>
            {{
              'tlc.members.edit_member.change_login_method_confirm_dialog.username_verification_title'
                | translate
            }}
          </span>
          <span
            [innerHTML]="
              'tlc.members.edit_member.change_login_method_confirm_dialog.username_verification_description'
                | translate: { username: usernameValue }
            "
          >
          </span>
        </div>
        <div layout-vertical>
          <span text-bold text-color>
            {{
              'tlc.members.edit_member.change_login_method_confirm_dialog.password_verification_title'
                | translate
            }}
          </span>
          {{
            'tlc.members.edit_member.change_login_method_confirm_dialog.password_verification_description'
              | translate
          }}
        </div>
      </div>
    </rt-confirm-dialog>
  `,
})
export class ChangeLoginMethodConfirmDialogComponent
  extends DialogComponent<ChangeLoginMethodConfirmDialog, boolean>
  implements OnInit
{
  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public email = signal<string>('');
  public username = signal<string>('');

  public ngOnInit(): void {
    const data = this.dialogData;
    if (data) {
      this.email.set(data.email);
      this.username.set(data.username);
    }
  }
}
